import { FC, useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useCollectionData } from "react-firebase-hooks/firestore"
import { firestore } from "../firebase";
import Task from "./Task";
 
interface TaskViewProps {
    user: any
}

const TaskView: FC<TaskViewProps> = ({user}) => {
    // const [user] = useAuthState(auth)

    const [savedTasks, setSaveTasks] = useState(JSON.parse(localStorage.getItem("savedTasks") || "[]"))

    let savedTasksRef 
    if(user) {
        savedTasksRef = firestore.collection(`${user.uid}`)
    }
    const [tasks] = useCollectionData(savedTasksRef, {idField: 'id'})

    try {
        
    }
    catch {

    }

    
    useEffect(() => {
        if(!user) {
            setTimeout(() => {
                const item = JSON.parse(localStorage.getItem("savedTasks") || "[]")
            
                if (item) {
                    setSaveTasks(item)
                }    
            }, 500);
        }
    })

    useEffect(() => {
        setTimeout(() => {
            if(user) {
                console.log(user)
            }
            console.log(user)
        }, 500);
    },[])

    return (
        <div className="task-view">
            <h2>Tasks:</h2>
            <hr />
            <>

                {user && tasks?.map((task: any, index: any) => <Task taskId={task.taskId} taskName={task.taskName} isCompleted={task.isCompleted} index={index} /> ) }

                {!user && savedTasks.map((savedTask: any, index: number) => <Task taskId={savedTask.taskId} 
                taskName={savedTask.taskName} isCompleted={savedTask.isCompleted} 
                index={index}/> )} 

            </>

        </div>
    );
}
 
export default TaskView;